// src/components/layout/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-cbre-green text-white h-40">
      <div className="container mx-auto px-4 py-8 h-full flex flex-col items-center justify-center space-y-2">
        <p className="text-center">© 2024 CBRE</p>
        <p className="text-center">Powered by Anirudh, Aaryan, and Vardhan</p>
      </div>
    </footer>
  );
};

export default Footer;